(function () {
  'use strict';

  function initMedia(media) {
    var video = media.querySelector('[data-tbb-video]');
    var playBtn = media.querySelector('[data-tbb-video-play]');
    var muteBtn = media.querySelector('[data-tbb-video-mute]');
    var muteIcon = media.querySelector('[data-tbb-mute-icon]');

    if (!video) return;

    var autoplay = media.getAttribute('data-autoplay') === 'true';

    function setPlayingState(isPlaying) {
      media.setAttribute('data-playing', isPlaying ? 'true' : 'false');
    }

    function playVideo() {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise
          .then(function () {
            setPlayingState(true);
          })
          .catch(function () {
            // Autoplay was blocked (common when unmuted) — force mute and retry once.
            if (!video.muted) {
              video.muted = true;
              updateMuteIcon(true);
              video.play().then(function () {
                setPlayingState(true);
              }).catch(function () {
                setPlayingState(false);
              });
            } else {
              setPlayingState(false);
            }
          });
      } else {
        setPlayingState(true);
      }
    }

    function updateMuteIcon(isMuted) {
      if (!muteIcon) return;
      if (isMuted) {
        muteIcon.innerHTML = '<path d="M11 5L6 9H2v6h4l5 4V5z"></path><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line>';
      } else {
        muteIcon.innerHTML = '<path d="M11 5L6 9H2v6h4l5 4V5z"></path><path d="M15.5 8.5a5 5 0 010 7"></path><path d="M18.5 5.5a9 9 0 010 13"></path>';
      }
    }

    if (playBtn) {
      playBtn.addEventListener('click', function () {
        playVideo();
      });
    }

    if (muteBtn) {
      muteBtn.addEventListener('click', function () {
        video.muted = !video.muted;
        updateMuteIcon(video.muted);
      });
      updateMuteIcon(video.muted);
    }

    video.addEventListener('pause', function () {
      setPlayingState(false);
    });
    video.addEventListener('play', function () {
      setPlayingState(true);
    });
    video.addEventListener('ended', function () {
      if (!video.loop) setPlayingState(false);
    });

    if (autoplay) {
      // Autoplaying video must be muted to satisfy browser policies.
      video.muted = true;
      updateMuteIcon(true);
      playVideo();
    }

    // Pause off-screen autoplay video to save bandwidth/battery, resume on re-entry.
    if (autoplay && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (video.paused) playVideo();
            } else if (!video.paused) {
              video.pause();
            }
          });
        },
        { threshold: 0.35 }
      );
      observer.observe(media);
    }
  }

  function init() {
    var mediaBlocks = document.querySelectorAll('[data-tbb-video-media]');
    mediaBlocks.forEach(initMedia);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var mediaBlocks = event.target.querySelectorAll('[data-tbb-video-media]');
    mediaBlocks.forEach(initMedia);
  });
})();
